import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DashboardsDisplayGridRowDataFragmentGql } from './DashboardsDisplayGridRowFragmentGql';

export const DatasourceDownstreamDashboardsQueryGql: DocumentNode = gql`
query DatasourceDownstreamDashboardsQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  publishedDatasources(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamDashboardsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowDataFragment
      }
    }
  }
}
${DashboardsDisplayGridRowDataFragmentGql}
`;
